import { useApi } from '../hooks/userApi';

export const api = useApi();
